<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">Bulk Configure Phones</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
  </div>
  @if (hasPhonesToConfigure == true) {
    <mat-dialog-content>
      <form class="extension-form" [formGroup]="form" (ngSubmit)="onCreate()">
        <table class="form-table">
          <thead>
            <tr>
              <th class="header-row">Add</th>
              <th class="header-row">Model</th>
              <th class="header-row">Mac Address</th>
              <th class="header-row">Extension #</th>
              <th class="header-row">Name</th>
              <th class="header-row">Display Name</th>
              <th class="header-row">Line Limit</th>
              <th class="header-row">Default Phone #</th>
              <th class="header-row">Mailbox Email Address</th>
            </tr>
          </thead>
          <tbody formArrayName="formArray">
            @for (formGroup of formArray.controls; track formGroup; let i = $index) {
              <tr [formGroupName]="i">
                <td>
                  <mat-checkbox
                    (change)="onIsConfigureThisPhone(i, $event)"
                    formControlName="isConfigureThisPhone"
                    class="configure-checkbox"
                    >
                  </mat-checkbox>
                </td>
                <td class="small-field">
                  <span>{{ formGroup.get('model')?.value }}</span>
                </td>
                <td class="small-field">
                  <span>{{ formGroup.get('macAddress')?.value | macAddress }}</span>
                </td>
                <td>
                  <mat-form-field class="input-field-boxes">
                    <input matInput autocomplete="off" type="tel" formControlName="number" />
                    @if (formGroup.get('number')?.hasError('required')) {
                      <mat-error>
                        Number Field is Required.
                      </mat-error>
                    }
                    @if (formGroup.get('number')?.hasError('pattern')) {
                      <mat-error>
                        Invalid Number Format
                      </mat-error>
                    }
                    @if (formGroup.get('number')?.hasError('min') || formGroup.get('number')?.hasError('max')) {
                      <mat-error
                        >
                        Number must be between 100-99999.
                      </mat-error>
                    }
                    @if (formGroup.get('number')?.hasError('nonUnique')) {
                      <mat-error
                        >Duplicate extensions not allowed.</mat-error
                        >
                      }
                      @if (formGroup.get('number')?.hasError('extensionAlreadyExists')) {
                        <mat-error
                          >Extension number already in use.</mat-error
                          >
                        }
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field class="input-field-boxes">
                        <input matInput autocomplete="off" type="text" formControlName="name" />
                        @if (formGroup.get('name')?.hasError('required')) {
                          <mat-error>
                            Name Field is Required
                          </mat-error>
                        }
                        @if (formGroup.get('name')?.hasError('pattern')) {
                          <mat-error> Invalid Name </mat-error>
                        }
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field class="input-field-boxes">
                        <input matInput autocomplete="off" type="text" formControlName="displayName" />
                        @if (formGroup.get('displayName')?.hasError('required')) {
                          <mat-error>
                            Name Field is Required
                          </mat-error>
                        }
                        @if (formGroup.get('displayName')?.hasError('pattern')) {
                          <mat-error> Invalid Name </mat-error>
                        }
                      </mat-form-field>
                    </td>
                    <td class="line-limit-input">
                      <mat-form-field class="input-field-boxes">
                        <input matInput autocomplete="off" type="number" formControlName="numberOfLineKeys" />
                        @if (formGroup.get('numberOfLineKeys')?.hasError('required')) {
                          <mat-error>
                            Line Limit is required.
                          </mat-error>
                        }
                        @if (formGroup.get('numberOfLineKeys')?.hasError('pattern')) {
                          <mat-error>
                            Invalid Number Format
                          </mat-error>
                        }
                        @if (
                          formGroup.get('numberOfLineKeys')?.hasError('min') ||
                          formGroup.get('numberOfLineKeys')?.hasError('max')
                          ) {
                          <mat-error
                            >
                            Must be between 1-30.
                          </mat-error>
                        }
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field class="flex-half input-field-boxes">
                        <input
                          [lcsSingleSelect]="phoneNumberSelect"
                          [accountId]="accountId"
                          ndtPhoneNumberSelect
                          autocomplete="off"
                          type="text"
                          formControlName="defaultPhoneNumber"
                          id="extension-phone-default-phone-number"
                          />
                          <ndt-phone-number-select
                            #phoneNumberSelect
                            [isIncludeEmptyOption]="true"
                            [onlyAllowOutboundCallsNumbers]="true"
                          ></ndt-phone-number-select>
                        </mat-form-field>
                      </td>
                      <td class="email-input input-field-boxes">
                        <mat-form-field>
                          <input matInput autocomplete="off" type="text" formControlName="emailAddress" />
                          @if (
                            formGroup.get('emailAddress')?.hasError('email') ||
                            formGroup.get('emailAddress')?.hasError('pattern')
                            ) {
                            <mat-error
                              >
                              Invalid email address
                            </mat-error>
                          }
                        </mat-form-field>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </form>
          </mat-dialog-content>
        }
        @if (hasPhonesToConfigure == true) {
          <mat-dialog-content>
            <mat-dialog-actions>
              <button type="submit" (click)="submitForm()" title="Create" mat-raised-button [disabled]="isSubmitting"
                >Save</button
                >
              </mat-dialog-actions>
            </mat-dialog-content>
          }
          <td>
            @if (hasPhonesToConfigure == false) {
              <mat-dialog-content class="no-phones-available">
                <h3>No Phones Available For Configuration</h3>
              </mat-dialog-content>
            }
          </td>
        </lcs-loading-overlay>
